import { createSlice } from "@reduxjs/toolkit";

/**
 *
 * @type IndustryStoreState
 */
const initialState = {
  permissionList: {
    loading: false,
    data: JSON.parse(localStorage.getItem("permissions")),
    error: null,
  },
};

export const Permissions = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    fetchPermissionListRequest: (state, action) => {
      state.permissionList.loading = true;
      state.permissionList.error = null;
    },
    fetchPermissionListSuccess: (state, action) => {
      localStorage.setItem("permissions", JSON.stringify(action.payload.data));
      state.permissionList.data = action.payload;
      state.permissionList.loading = false;
      state.permissionList.error = null;
    },
    fetchPermissionListFailure: (state, action) => {
      state.permissionList.data = null;
      state.permissionList.loading = false;
      state.permissionList.error = action.payload;
    },
  },
});

export const {
  fetchPermissionListRequest,
  fetchPermissionListSuccess,
  fetchPermissionListFailure,
} = Permissions.actions;

/**
 *
 * @param {*} store
 * @returns {IndustryStoreState['industryList']}
 */
export const getPermissionListState = (store) =>
  store.permissions?.permissionList;

export default Permissions.reducer;
